import { combineReducers } from 'redux';

import clues from './clues';
import items from './items';
import providers from './providers';
import routes from './routes';
import products from './products';
import bookings from './bookings';
import filters from './filters';
import users from './users';
import places from './places';
import moreToExploreCollection from './moreToExploreCollection';
import sparks from './sparks';
import challenges from './challenges';
import virtuals from './virtuals';
import medias from './medias';
import storyboards from './storyboards';

const rootReducers = combineReducers({
  clues,
  items,
  providers,
  routes,
  products,
  bookings,
  filters,
  users,
  places,
  moreToExploreCollection,
  sparks,
  challenges,
  virtuals,
  medias,
  storyboards,
});

export default rootReducers;
